/**
 * Scroll Freeze Utilities
 *
 * Utilities for freezing and unfreezing scroll on the page
 * when Focus Mode is active.
 */

/**
 * Freeze scrolling on the page
 * Preserves scroll position for when unfreezing
 */
export function freezeScroll() {
  const scrollY = window.scrollY;

  // Freeze body
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';

  // Add frozen class to feed containers
  const feedContainers = document.querySelectorAll(
    '.feed-container, [class*="overflow-y-auto"]'
  );
  feedContainers.forEach(el => {
    el.classList.add('scroll-frozen');
  });
}

/**
 * Unfreeze scrolling and restore scroll position
 */
export function unfreezeScroll() {
  const scrollY = document.body.style.top;

  // Restore body
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  document.body.style.overflow = '';

  // Restore scroll position
  if (scrollY) {
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }

  // Remove frozen class from feed containers
  const feedContainers = document.querySelectorAll('.scroll-frozen');
  feedContainers.forEach(el => {
    el.classList.remove('scroll-frozen');
  });
}

/**
 * Format remaining time in HH:MM:SS or MM:SS format
 * @param seconds - Total seconds remaining
 * @returns Formatted time string
 */
export function formatRemainingTime(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${minutes}:${secs.toString().padStart(2, '0')}`;
}
